<style lang="less" scoped>
@import '../../../style/common/variable';
.dhxwList{position: relative;width: 100%;margin: 0px auto;padding: 0;background: #fff;}
.mains{width: 1000px;display: flex;margin: 0px auto;}
.first{display: flex;flex-direction: column;width: 1000px;margin-right: 20px;
    .details{position: relative;width: 1000px; justify-content: center;overflow: hidden;}
    .first{margin-bottom: 50px;}
    img {vertical-align: middle;}
    .title { margin-top: 32px;font-size: 24px;text-align: center;}
    .subbox {display: flex;justify-content: center;align-items: center;height: 24px;margin: 16px 0px;}
    .time {margin-right: 100px;}
    .copyfrom{margin-right: 100px;}
    .second{position: relative;}
    .keywords{font-weight: 600;}
    .keywordsItem{margin: 0px 10px;}
    .keywordsItem:hover{color: #13569e;cursor: pointer;}
    ul{position: absolute;top: -16px;left: 30px;list-style: none;display: flex;color: rgb(145, 142, 142)}
    .preArticle{font-weight: 600;}
    .nextArticle{font-weight: 600;}
    .otherTitle{cursor: pointer;}
    .otherTitle:hover{color: #13569e;}
    .content {color: #2c3e50 !important;}
    .content a {color: #2c3e50 !important;}
}
.details {text-align: left;}
@media screen and (max-width: @max-screen){
  .mains{width: 100vw;}
  .details{
    .first{width: 96vw; margin-left: 2vw;
      .subbox{flex-direction: column;justify-content: center;align-items: center;
        .time{margin-right: 0;}
        .copyfrom{margin-right: 0;}
      }
    }
  }
}
</style>

<template>
  <div class="dhxwList">
    <Navigation v-if="this.catid !== ''" :navigationdatas="navigationList2"></Navigation>
    <Navigation v-else :navigationdatas="navigationList"></Navigation>
    <div class="mains">
      <div class="first">
        <div class="details">
            <div class="first">
            <h1 class="title">{{ curArticle.title }}</h1>
            <div class="subbox">
                <span class="time" v-if="curArticle.id">发布时间：{{ curArticle.time * 1000 | formatDate() }} </span>
                <span class="copyfrom" v-if="curArticle.id">来源：{{ curArticle.copyfrom }}</span>
                <span class="hits" v-if="curArticle.id">浏览数：{{ curArticle.hits }}</span>
            </div>
            <div class="content" v-html="curArticleContent"></div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '../assembly/Navigation'
// import Details from '../assembly/Details'
import filters from '../method/filter.js'

export default {
  components: {Navigation},
  mixins: [filters],
  name: '',
  data()
  {
    return {
      articledata: [], // 所有文章的相关信息
      curID: null, // 当前展示文章的id
      catID: null, //详情文章的catID
      curArticle: {}, // 当前展示文章的相关信息
      curArticleContent: null, // 当前展示文章的正文内容
      preArticle: {}, // 上一篇文章相关信息
      nextArticle: {}, // 下一篇文章相关信息
      curIndex: null, // 当前文章的索引值
      nopre: false, //没有上一篇
      nonext: false, //没有下一篇
      navigationList: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '矿业论坛',
          path: '/Promoin'
        },
        {
          theme: '会议资讯',
          path: ''
        }
      ],
      navigationList2: [
        {
          theme: '首页',
          path: '/Kyforum'
        },
        {
          theme: '矿业论坛',
          path: '/Promoin'
        },
        {
          theme: '会议资讯',
          path: '/NewsKyzhzx'
        },
        {
          theme: '正文',
          path: ''
        }
      ]
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.curID = +nval.query.id
        this.getDetails()
      },
      immediate: true
    }
  },
  methods: {
    getDetails()
    {
      // 从矿业资讯的数据表中获取所有文章的相关信息
      if (this.$route.path === '/KyzxDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.edittime, copyfrom: item.copyfrom, hits: item.hits, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从资料库的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/ZlkDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会新闻的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/DhxwDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会新闻的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/LtgkDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      else if (this.$route.path === '/KyzhzxDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 118, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            let keyArr = item.keyword.split(',')
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, keyword: keyArr, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
      // 从大会资讯的数据表中获取所有文章的相关信息
      else if (this.$route.path === '/HyxqDetails')
      {
        let paras1 = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id<=? and catid != 0 and examine = 0', types: 'i', vals: this.curID + 5, orderby: 'id DESC', init: 0, pageno: 1, pagesize: 11}
        window.post.getPost(paras1).then((ret) =>
        {
          let temp = []
          ret[0].data.forEach(item =>
          {
            temp.push({id: item.id, title: item.title, time: item.addtime, copyfrom: item.copyfrom, hits: item.hits, catid: item.catid})
          })
          this.articledata = temp
          this.show()
        })
      }
    },
    // 当前展示文章
    show()
    {
      // 当前展示文章的相关信息
      this.articledata.forEach(item =>
      {
        if (parseInt(item.id) === this.curID) //当前ID数据存在
          this.curArticle = item
      })
      // 从矿业资讯的数据表中获取当前展示文章的正文内容
      if (this.$route.path === '/KyzxDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 2, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 1, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 1, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从资料库的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/ZlkDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 25, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 24, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 24, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从大会新闻的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/DhxwDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 6, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 5, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      else if (this.$route.path === '/LtgkDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 6, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 5, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 5, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      else if (this.$route.path === '/KyzhzxDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 119, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 118, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 118, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      // 从大会资讯的数据表中获取当前展示文章的正文内容
      else if (this.$route.path === '/HyxqDetails')
      {
        let paras2 = {cmd: 'query', _major: 11, _minor: 51, _exp: 'id=?', types: 'i', vals: this.curID}
        window.post.getPost(paras2).then((ret) =>
        {
          if (ret.length === 0)//当前ID数据不存在
            this.curArticleContent = null
          else//当前ID数据存在
          {
            this.curArticleContent = window.public.decodeContent(ret[0].content)
            let parasUP = {cmd: 'query', _major: 11, _minor: 50, _exp: 'id=? and examine = 0', types: 'i', vals: this.curID}
            window.post.getPost(parasUP).then((ret) =>
            {
              let parasUD = {cmd: 'updateAtt', _major: 11, _minor: 50, id: this.curID, hits: ret[0].hits + 1}
              window.post.getPost(parasUD).then((ret) =>
              {
              })
            })
          }
        })
      }
      this.curIndex = this.articledata.indexOf(this.curArticle)
      if (this.curIndex > 0)
      {
        this.preArticle = this.articledata[this.curIndex - 1]
        this.nextArticle = this.articledata[this.curIndex + 1]
        this.nopre = false
      }
      else
      {
        this.nopre = true
        this.nextArticle = this.articledata[this.curIndex + 1]
      }
    },
    _isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyzhzxDetails.vue